module.exports = __webpack_public_path__ + "static/labalm-886cc147b3840a2c57e67fc22b6ac2cc.jpg";